<template>
  <main>
    <div class="error no-print" v-if="!hasCameraSupport">
      Device does not support camera.
      <p v-if="errorMsg">{{errorMsg}}</p>
    </div>
    <div class="camera-container" v-else>
      <div class="background" :class="{'hidden' : screenshotCaptured, 'hidden': countdownActive}">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 768"><g id="Dashed_line" data-name="Dashed line"><path class="cls-1" d="M-69.61-55a619.57,619.57,0,0,0,75,119.76C27.21,92.16,53.2,118.82,87,128.27c15.43,4.32,31.65,4.77,47.67,4.92,55.3.54,110.92-2.13,165-13.7,18.75-4,37.7-9.28,53.41-20.29s27.78-28.78,27.45-47.95C380.17,31.16,366.28,13.19,349,2.93s-37.55-14-57.46-16.64C204.81-25,114.49-16.8,34.26,18.05,20,24.22,5.82,31.46-4.69,42.87c-24.69,26.8-22.18,70.18-5,102.33s45.86,56.21,72.28,81.3c26.72,25.38,52.14,53.25,67.15,86.9s18.33,74.17,1.23,106.81c-12,23-35.58,41.25-61.53,41.13S18,438.43,20.17,412.57c2.51-30.17,37.27-47.43,67.54-47.46,34.18,0,70.9,17.62,82,49.92,11.95,34.69-9.11,72.73-36.58,97S71.65,552.53,45,577.74s-45.27,65.2-30,98.55C29.89,708.65,70,721,105.58,721.2c19.3.11,39.13-2.44,56.09-11.66s30.63-26,32.12-45.3a47.74,47.74,0,0,0-24-44.45c-15.58-8.59-36.13-7.19-50.39,3.45C108.17,631.62,101,646.41,104.53,660c4,15.19,19.44,24.31,34.22,29.64a167.85,167.85,0,0,0,96,5.13c20.77-5.06,40.54-14.11,61.67-17.34,30-4.59,80.62-37.84,105.81-21.65"/><polygon class="cls-2" points="392.34 659.89 391.86 657.95 401.43 655.58 398.37 646.2 400.27 645.58 404 657 392.34 659.89"/></g><g id="Camera"><path class="cls-3" d="M291,645.19l5.91-1.38a1.86,1.86,0,0,1,1.62.68,18.33,18.33,0,0,1,1.83,3s5.29-1.34,5.87-1.36a7.23,7.23,0,0,1,3,.31,9.5,9.5,0,0,1,2.28,1.28c.58.54,2.14,7.24,2.14,7.24l1.81,7.8s.21,1.4-.29,1.91-.63,1.17-1.77,1.6-32.62,7.58-32.62,7.58A2.47,2.47,0,0,1,279,674c-.72-.4-1.77-.77-2.08-1.89s-3.3-14.16-3.3-14.16a2.39,2.39,0,0,1,.33-2c.67-.78,2.47-2.5,2.47-2.5a8.07,8.07,0,0,1-.37-1.61,1.84,1.84,0,0,1,.84-1.49,5.13,5.13,0,0,1,2.46-.86,1.69,1.69,0,0,1,1.83,1.1,4,4,0,0,1,.32,1.34l1.87-.44.36-3.3s.27-1.32,1-1.52S291,645.19,291,645.19Z"/><line class="cls-4" x1="284.34" y1="641.42" x2="287.51" y2="644.53"/><line class="cls-4" x1="289.07" y1="639.34" x2="290.23" y2="643.63"/><line class="cls-4" x1="294.84" y1="639.09" x2="293.2" y2="643.22"/><line class="cls-4" x1="296.62" y1="647.72" x2="287.12" y2="649.95"/><line class="cls-4" x1="297.12" y1="649.87" x2="287.62" y2="652.09"/><circle class="cls-4" cx="294.6" cy="660.4" r="5.78"/><path class="cls-4" d="M293.35,657.47a3.31,3.31,0,0,1,3,.44,3.24,3.24,0,0,1,1.21,2.26"/><path class="cls-4" d="M274,659.6l13.45-3.13a11.35,11.35,0,0,0-.6,5.74c.63,2.57,3.46,5.13,3.46,5.13l-13.77,3.21"/><path class="cls-4" d="M312.52,650.47l-13.45,3.13a11.3,11.3,0,0,1,3.07,4.89c.57,2.58-.83,6.13-.83,6.13l13.76-3.2"/><rect class="cls-4" x="304.39" y="654.18" width="6.66" height="3.52" rx="1.76" transform="translate(-140.58 86.75) rotate(-13.09)"/></g></svg>
      </div>
      <div class="inner">
        <h1 class="no-print">Boliden Photobooth {{version}}</h1>

        <div :class="{'hidden' : screenshotCaptured}">
          <div class="video-stream no-print">

            <!-- countdown -->
            <transition name="fade">
              <div class="countdown" v-if="countdownActive">
                <span id="currentTime">{{currentTime}}</span>
              </div>
            </transition>

            <!-- flash -->
            <div class="flash" id="flash"></div>

            <video autoplay playsinline ref="videoStream"></video>
          </div>
          <button
            :class="{'clicked' : buttonActive, 'hidden': countdownActive }"
            class="no-print snap-photo"
            @click="beginCountdown">Snap a photo
            <span class="countdown-symbol">
            <img src="~@/assets/countdown.png" alt="Circle with number three."
                 width="134" height="144" />
          </span>
          </button>
        </div>

        <div class="screenshot">
          <h2 class="no-print" v-if="screenshotCaptured">Hey, look at you, good lookin'!</h2>
          <canvas class="no-print screenshot-canvas" ref="screenshotCanvas"
                  width="1024" height="768"></canvas>
          <div class="print-actions no-print">
            <button class="no-print retake" v-if="screenshotCaptured"
                    @click="restart">Re-take</button>

            <button class="no-print to-printer" v-if="screenshotCaptured"
                    @click="printImage">Print</button>
          </div>
          <div class="print-only">
            <img ref="screenshotImg" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import gsap from 'gsap';

export default {
  data() {
    return {
      buttonActive: false,
      hasCameraSupport: false,
      videoDevice: null,
      stream: null,
      errorMsg: '',
      screenshotCaptured: false,
      currentTime: 3,
      countdownActive: false,
      reviewPhoto: false,
      version: 3,
      serverURL: 'https://10.167.85.126/boliden-photo-saver/index.php',
      mediaConstraints: {
        video: {
          width: {
            min: 1280,
            ideal: 1920,
            max: 2560,
          },
          height: {
            min: 720,
            ideal: 1080,
            max: 1440,
          },
          facingMode: 'user',
        },
      },
    };
  },
  methods: {
    buttonIsActive() {
      this.buttonActive = true;
    },
    buttonIsInactive() {
      this.buttonActive = false;
    },
    forceSWupdate() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          // eslint-disable-next-line no-restricted-syntax
          for (const registration of registrations) {
            registration.update();
          }
        });
      }
    },
    restart() {
      const canvas = this.$refs.screenshotCanvas;
      const video = this.$refs.videoStream;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);

      this.screenshotCaptured = false;
    },
    beginCountdown() {
      this.countdownActive = true;
      setTimeout(this.decreaseSnapshotTime, 1000 + 300); // 1 second + fade-in time
    },
    decreaseSnapshotTime() {
      if (this.currentTime === 0) {
        this.showFlash();
        this.currentTime = 3;
        this.countdownActive = false;
      } else {
        gsap.fromTo('#currentTime',
          {
            opacity: 0,
            scale: 5,
          },
          {
            opacity: 1,
            scale: 1,
            duration: 1,
            onComplete: () => {
              this.currentTime -= 1;
              this.decreaseSnapshotTime();
            },
          });
      }
    },
    showFlash() {
      gsap.set('#flash', { opacity: 0 });
      gsap.to('#flash', {
        opacity: 0.8,
        duration: 0.1,
        yoyo: true,
        repeat: 1,
        onComplete: this.takeScreenshot,
      });
    },
    takeScreenshot() {
      const canvas = this.$refs.screenshotCanvas;
      const video = this.$refs.videoStream;
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
      canvas.getContext('2d').drawImage(video, 0, 0);

      this.$refs.screenshotImg.src = canvas.toDataURL('image/webp');

      this.screenshotCaptured = true;
    },
    printImage() {
      const canvas = this.$refs.screenshotCanvas;
      const base64Img = canvas.toDataURL('image/jpeg', 1.0);

      const data = new FormData();
      data.set('img', base64Img);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', this.serverURL, true);
      // eslint-disable-next-line func-names
      xhr.onload = function () {
        if (xhr.status !== 200) {
          console.error('error from server', xhr);
          return;
        }
        console.log('Image sent to printing folder…');
      };
      xhr.send(data);
      this.restart();
    },
    getCamera() {
      console.log('Getting available devices…');
      navigator.mediaDevices.enumerateDevices()
        .then((devices) => {
          const availableDevices = devices.filter((device) => device.kind === 'videoinput');
          if (availableDevices.length > 0) {
            // eslint-disable-next-line prefer-destructuring
            this.videoDevice = availableDevices[0];
            console.log('Video device is:', this.videoDevice.label);

            const updatedConstraints = {
              ...this.mediaConstraints,
              deviceId: {
                exact: this.videoDevice.deviceId,
              },
            };
            this.startStream(updatedConstraints);
          }
        });
    },
    startStream(constraints) {
      navigator.mediaDevices.getUserMedia(constraints)
        .then((mediaStream) => {
          this.stream = mediaStream;
          this.hasCameraSupport = true;
          this.attachVideo();
        })
        .catch((error) => {
          this.hasCameraSupport = false;
          this.errorMsg = error;
        });
    },
    attachVideo() {
      this.$nextTick(() => {
        if (this.stream !== null) {
          this.$refs.videoStream.srcObject = this.stream;
          this.$refs.videoStream.play();
        }
      });
    },
  },
  mounted() {
    this.forceSWupdate();
    // From https://www.digitalocean.com/community/tutorials/front-and-rear-camera-access-with-javascripts-getusermedia.amp
    if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
      this.getCamera();
    }
  },
};
</script>
